import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["caret", "children"],
  _excluded2 = ["bg", "backgroundColor"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default from 'react';
import { ThemeContext } from 'styled-components';
import Caret from '../Caret.js';
import { get } from '../constants.js';
import Box from '../Box/Box.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// FIXME: Make this work with BetterStyledSystem types

function PointerBox(props) {
  // don't destructure these, just grab them
  var themeContext = React__default.useContext(ThemeContext);
  var bg = props.bg,
    border = props.border,
    borderColor = props.borderColor,
    themeProp = props.theme,
    sx = props.sx;
  var caret = props.caret,
    children = props.children,
    boxProps = _objectWithoutProperties(props, _excluded);
  var _ref = sx || {},
    sxBg = _ref.bg,
    backgroundColor = _ref.backgroundColor,
    sxRest = _objectWithoutProperties(_ref, _excluded2);
  var theme = themeProp || themeContext;
  var customBackground = bg || sxBg || backgroundColor;
  var caretProps = {
    bg: bg || (sx === null || sx === void 0 ? void 0 : sx.bg) || (sx === null || sx === void 0 ? void 0 : sx.backgroundColor),
    borderColor: borderColor || (sx === null || sx === void 0 ? void 0 : sx.borderColor),
    borderWidth: border,
    location: caret,
    theme: theme
  };
  var defaultBoxProps = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.default',
    borderRadius: 2
  };
  return /*#__PURE__*/React__default.createElement(Box, _extends({}, defaultBoxProps, boxProps, {
    sx: _objectSpread(_objectSpread({}, sxRest), {}, {
      '--custom-bg': get("colors.".concat(customBackground))({
        theme: theme
      }),
      backgroundImage: customBackground ? "linear-gradient(var(--custom-bg), var(--custom-bg)), linear-gradient(".concat(theme.colors.canvas.default, ", ").concat(theme.colors.canvas.default, ")") : undefined,
      position: 'relative'
    })
  }), children, /*#__PURE__*/React__default.createElement(Caret, caretProps));
}
PointerBox.displayName = "PointerBox";
export { PointerBox as default };